import React from "react";
import Select from "react-select";

const NAVY = "#1a237e";

export const expenseSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 31,
        fontSize: "0.875rem",
        borderColor: state.isFocused ? NAVY : "#ced4da",
        boxShadow: state.isFocused ? "0 0 0 0.15rem rgba(26, 35, 126, 0.2)" : "none",
        "&:hover": { borderColor: NAVY },
        cursor: "text",
    }),
    valueContainer: (base) => ({ ...base, padding: "0 8px" }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
    indicatorsContainer: (base) => ({ ...base, height: 31 }),
    menu: (base) => ({ ...base, zIndex: 9999, fontSize: "0.875rem" }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
        ...base,
        fontSize: "0.875rem",
        backgroundColor: state.isSelected ? NAVY : state.isFocused ? "#e8eaf6" : "#fff",
        color: state.isSelected ? "#fff" : "#333",
    }),
    placeholder: (base) => ({ ...base, fontSize: "0.875rem", color: "#6c757d" }),
    singleValue: (base) => ({ ...base, fontSize: "0.875rem" }),
};

const defaultFilter = (option, input) => {
    if (!input) return true;
    const needle = input.toLowerCase();
    const label = (option.label || "").toLowerCase();
    const address = (option.data?.address || "").toLowerCase();
    return label.includes(needle) || address.includes(needle);
};

export const findSelectOption = (options, value) => {
    if (value === "" || value === null || value === undefined) {
        return null;
    }
    return options.find((o) => o.value === String(value)) ?? null;
};

export const mapToSelectOptions = (items, { valueKey = "id", labelFn } = {}) => {
    return (items || []).map((item) => ({
        value: String(item[valueKey]),
        label: labelFn ? labelFn(item) : (item.name || item.label || ""),
    }));
};

export const mapVendorSelectOptions = (vendors) => {
    return (vendors || []).map((vendor) => ({
        value: String(vendor.id),
        label: vendor.name || "",
        address: vendor.address || "",
        data: vendor,
    }));
};

export const formatVendorOptionLabel = (option, { context }) => {
    if (context === "value") {
        return option.label;
    }

    return (
        <div style={{ lineHeight: 1.25, padding: "2px 0" }}>
            <div style={{ fontWeight: 600 }}>{option.label}</div>
            {option.address ? (
                <div
                    style={{
                        fontSize: "0.72rem",
                        opacity: 0.8,
                        marginTop: 2,
                        whiteSpace: "normal",
                    }}
                >
                    <i className="fas fa-map-marker-alt me-1" style={{ fontSize: "0.65rem" }}></i>
                    {option.address}
                </div>
            ) : (
                <div style={{ fontSize: "0.72rem", opacity: 0.55, marginTop: 2 }}>No address</div>
            )}
        </div>
    );
};

export default function ExpenseSearchSelect({
    options = [],
    value,
    onChange,
    placeholder = "Search...",
    isDisabled = false,
    isClearable = false,
    isSearchable = true,
    menuPortal = true,
    openMenuOnFocus = true,
    inputId,
    selectRef,
    onKeyDown,
    className,
    noOptionsMessage = () => "No matches",
    filterOption = defaultFilter,
    formatOptionLabel,
    styles: stylesOverride,
}) {
    const styles = stylesOverride
        ? { ...expenseSelectStyles, ...stylesOverride }
        : expenseSelectStyles;

    return (
        <Select
            ref={selectRef}
            inputId={inputId}
            className={className}
            classNamePrefix="expense-select"
            options={options}
            value={findSelectOption(options, value)}
            onChange={(opt) => onChange(opt ? opt.value : "")}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            isDisabled={isDisabled}
            isClearable={isClearable}
            isSearchable={isSearchable}
            openMenuOnFocus={openMenuOnFocus}
            filterOption={filterOption}
            formatOptionLabel={formatOptionLabel}
            styles={styles}
            menuPortalTarget={menuPortal ? document.body : undefined}
            menuPosition={menuPortal ? "fixed" : undefined}
            noOptionsMessage={noOptionsMessage}
        />
    );
}
